import { render, staticRenderFns } from "./BrandList.vue?vue&type=template&id=5d6173ac&scoped=true"
import script from "./BrandList.vue?vue&type=script&lang=js"
export * from "./BrandList.vue?vue&type=script&lang=js"
import style0 from "./BrandList.vue?vue&type=style&index=0&id=5d6173ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6173ac",
  null
  
)

export default component.exports